<template>
    <div class="main-content bg-white">
        <div class="page-header">
            <h3 class="page-title">Отчёт по офферам</h3>
        </div>
        <div class="row mb-2">
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <v-select :options="isTestOptions"
                          :searchable="false"
                          :clearable="false"
                          v-model="isTest"
                          placeholder="Тест">
                </v-select>
            </div>
            <div :key="dateRange" class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <b-button-group v-if="isXl" class="datePickerXl ">
                    <date-range-picker
                            ref="picker"
                            :locale-data="dateRangeLocalFormat"
                            v-model="range"
                            :opens="'right'"
                            :ranges="dateRanges"
                            @update="selectRange($event)">
                        <template v-slot:input="picker" style="min-width: 350px;!important;">
                            {{ range.startDate | formatDateRange }} - {{ range.endDate | formatDateRange  }}
                        </template>
                    </date-range-picker>
                    <b-button size="sm" variant="primary">
                        <i class="icon-fa icon-fa-calendar-check-o"></i>
                    </b-button>
                </b-button-group>
                <b-input-group :key="dateRange" v-if="!isXl">
                    <div></div>
                    <b-input-group-append>
                        <datepicker input-class="form-control dateFrom"
                                    class="date dateLeft"
                                    size="sm"
                                    v-model="range.startDate"
                                    monday-first
                                    :language="ru"
                                    placeholder="С:">
                        </datepicker>
                        <datepicker input-class="form-control dateTo"
                                    class="date dateRight"
                                    monday-first
                                    size="sm"
                                    v-model="range.endDate"
                                    :language="ru"
                                    placeholder="По:">
                        </datepicker>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <v-select :options="selectOffers" :filter="filterOffers" required label="title" v-model="search"
                          placeholder="Оффер"

                          multiple>
                    <span slot="no-options">Совпадений не найдено.</span>
                    <template slot="option" slot-scope="option">
                        <span>({{option.id}}) {{ option.title }}</span>
                    </template>
                </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <v-select :options="sources" required

                          label="title" v-model="source" placeholder="Источник"
                          multiple>
                    <span slot="no-options">Совпадений не найдено.</span>
                </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <v-select :options="groups" required

                          v-model="group" placeholder="Группа" multiple>
                    <span slot="no-options">Совпадений не найдено.</span>
                </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" v-if="$currentUser.role == 'admin' || $currentUser.role == 'leader'">
                <v-select label="name" :options="users"

                          required v-model="user" placeholder="Медиабайер" multiple>
                    <span slot="no-options">Совпадений не найдено.</span>
                </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2"
                 v-if="this.$currentUser.department === 'adkey'">
                <v-select :options="applicationOwnerOptions"
                          placeholder="Приложение"
                          :clearable="false"
                          :searchable="false"
                          v-model="application_owner">
                </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
              <v-select :options="types"
                        placeholder="Тип"
                        :clearable="false"
                        :searchable="false"
                        multiple
                        v-model="type">
              </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" v-if="$currentUser.role != 'user'">
              <v-select
                id="account_manager"
                label="name"
                placeholder="Аккаунт"
                :options="accountManagers"
                :reduce="accountManager => accountManager.id"
                multiple
                v-model="account">
                <span slot="no-options">Совпадений не найдено.</span>
              </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
              <v-select
                placeholder="Сейл"
                label="name"
                :options="salesManagers"
                :reduce="manager => manager.id"
                required
                multiple
                v-model="filters.salesManagers">
                <span slot="no-options">Совпадений не найдено.</span>
              </v-select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
              <v-select
                :options="advertisers"
                placeholder="Рекламодатель"
                :reduce="advertiser => advertiser.value"
                required
                multiple
                v-model="filters.advertisers">
                <span slot="no-options">Совпадений не найдено.</span>
              </v-select>
            </div>
          <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
            <v-select :options="channels"
                      placeholder="Канал продаж"
                      :clearable="false"
                      :searchable="false"
                      :reduce="channel => channel.value"
                      multiple
                      v-model="channel">
            </v-select>
          </div>
        </div>
      <div class="row">
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
          <v-select :options="sub4Options"
                    placeholder="Subid-4"
                    label="text"
                    :clearable="false"
                    :searchable="false"
                    v-model="selectedSub4">
          </v-select>
        </div>
        <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
          <v-select label="name"
                    class="geoComponent"
                    :options="geo" size="sm" required v-model="selectedGeo" placeholder="ГЕО"
                    multiple>
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </div>
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
          <v-select :options="userGroups"
                    label="title"
                    placeholder="Группа пользователей"
                    :clearable="false"
                    :searchable="false"
                    :reduce="userGroup => userGroup.id"
                    multiple
                    v-model="selectedUserGroups">
          </v-select>
        </div>
      </div>
        <div class="row mt-2">
            <div class="col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton">
                <b-input-group>
                    <div></div>
                    <b-input-group-append>
                        <b-btn size="sm" text="Search" variant="success"
                               class="mainButton"
                               style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                               @click="getReports(1, {sortBy: sortBy, sortDesc: sortDesc}, user, search, true)">
                            Применить
                            <!--<i class="icon-fa icon-fa-search"></i>-->
                        </b-btn>
                        <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">Очистить
                            <!--<i class="icon-fa icon-fa-times"></i>-->
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div class="col-sm-2 col-md-6 col-lg-6 col-xl-8 mb-2 "></div>
            <div class="col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton">
                <b-button-group class="float-right  mainButton">
                    <a class="btn btn-outline-success btn-sm"
                       v-bind:href="getExcelParamsString('xlsx')">Excel</a>
                    <a class="btn btn-outline-success btn-sm"
                       v-bind:href="getExcelParamsString('csv')">CSV</a>
                </b-button-group>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div v-if="!isMobile">
                    <b-table hover responsive bordered
                             small
                             :items="reports"
                             :fields="fields"
                             no-local-sorting
                             :sort-by.sync="sortBy"
                             @sort-changed="getReports(1, $event, user, search)"
                             :busy="isBusy"
                             :sort-desc.sync="sortDesc"
                             :sort-direction="sortDirection">
                        <template slot="table-busy">
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Загрузка...</strong>
                            </div>
                        </template>
                        <template slot="roi" slot-scope="row">
                            <div v-if="row.item.roi !== null">{{row.item.roi}}</div>
                            <div v-if="row.item.roi === null">0.00</div>
                        </template>
                        <template slot="gm_rev" slot-scope="row">
                            <div v-if="row.item.gm_rev !== null">{{row.item.gm_rev}}</div>
                            <div v-if="row.item.gm_rev === null">0.00</div>
                        </template>
                    </b-table>
                </div>
                <div v-if="isMobile">
                    <b-table hover responsive bordered stacked
                             small
                             :items="reports"
                             :busy="isBusy"
                             :fields="fields"
                             no-local-sorting
                             :sort-by.sync="sortBy"
                             @sort-changed="getReports(1, $event,user, search)"
                             :sort-desc.sync="sortDesc"
                             :sort-direction="sortDirection">
                        <template slot="table-busy">
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Загрузка...</strong>
                            </div>
                        </template>
                        <template slot="roi" slot-scope="row">
                            <div v-if="row.item.roi !== null">{{row.item.roi}}</div>
                            <div v-if="row.item.roi === null">0.00</div>
                        </template>
                        <template slot="gm_rev" slot-scope="row">
                            <div v-if="row.item.gm_rev !== null">{{row.item.gm_rev}}</div>
                            <div v-if="row.item.gm_rev === null">0.00</div>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-sm-6">
                <div class="" role="status" aria-live="polite">Количество строк:
                    <b-form-select v-model="pageSize"
                                   style="width: 70px;"
                                   v-on:change="getReports()"
                                   size="sm">
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="75">75</option>
                        <option :value="100">100</option>
                        <option :value="150">150</option>
                        <option :value="200">200</option>
                    </b-form-select>
                </div>
                <div class="" role="status" aria-live="polite">Записей на странице: <span
                        v-if="reports && reports.length">{{ reports.length - 2 }}</span><span v-if="!reports">0</span>
                </div>
                <div class="" role="status" aria-live="polite">Всего записей: <span v-if="pager && pager.total">{{ pager.total }}</span><span
                        v-if="!pager || !pager.total">0</span></div>
            </div>
            <div class="col-sm-6">
                <div class="float-right">
                    <nav aria-label="Page navigation">
                        <ul class="pagination justify-content-center">
                            <b-pagination size="sm" :total-rows="pager.total"
                                          v-model="pager.current_page"
                                          v-on:change="getReports($event, {sortBy: sortBy, sortDesc: sortDesc},user, search)"
                                          :per-page="pager.per_page"></b-pagination>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import OffersService from '../../services/offersDataService'
    import SourcesService from '../../services/sourcesDataService'
    import ReportsService from '../../services/reportsDataService'
    import Ls from '../../services/ls'
    import {ru} from '../../services/customLocaleDatepicker'
    import Datepicker from 'vuejs-datepicker'
    import reportMixin from "./mixins/reportMixin";
    import datePickerMixin from "./mixins/datePickerMixin";
    import advertiserFormMixin from "./mixins/Advertiser/advertiserFormMixin";
    import salesManagerFormMixin from "./mixins/SalesManager/salesManagerFormMixin";
    import accountManagerFormMixin from "./mixins/AccountManager/accountManagerFormMixin";
    import saveFiltersMixin from "./mixins/saveFiltersMixin";
    import DateRangePicker from 'vue2-daterange-picker'

    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import vue2DateRangePickerMixin from "./mixins/vue2DateRangePickerMixin";
    import dataOptionsMixin from "./mixins/dataOptionsMixin";
    import UsersService from "../../services/usersDataService";

    export default {
        name: 'offersReportComponent',
        components: {
            Datepicker: Datepicker,
            DateRangePicker: DateRangePicker
        },
        mixins: [
            reportMixin,
            advertiserFormMixin,
            salesManagerFormMixin,
            accountManagerFormMixin,
            saveFiltersMixin,
            vue2DateRangePickerMixin,
            dataOptionsMixin
        ],
        data() {
            return {
                isBusy: true,
                filters: {
                  advertisers: [],
                  salesManagers: [],
                },
                selectedSub4: '',
                selectedGeo: [],
                userGroups: [],
                selectedUserGroups: [],
                geo: [],
                sources: [],
                group: [],
                pager: {},
                source: [],
                isTestOptions: [
                    {value: 0, label: 'Не тест'},
                    {value: 1, label: 'Тест'},
                    {value: null, label: 'Все данные'},
                ],
                channels: [
                  {
                    label: 'Конференция',
                    value: 'conference'
                  },
                  {
                    label: 'Нетворкинг',
                    value: 'networking'
                  },
                  {
                    label: 'Рекомендация',
                    value: 'recommendation'
                  },
                  {
                    label: 'Холодные продажи',
                    value: 'coldsale'
                  },
                  {
                    label: 'Запрос через сайт/соц.сети',
                    value: 'website'
                  }
                ],
                isTest: {value: 0, label: 'Не тест'},
                user: this.$currentUser.role == 'leader' ? [this.$currentUser] : null,
                account: this.$currentUser.role == 'account' ? [this.$currentUser.id] : [],
                users: [],
                accounts: [],
                reports: [],
                groups: [],
                channel: [],
                fields: [
                    {
                        key: 'offer_title',
                        label: 'Оффер',
                        sortable: true
                    },
                    {
                        key: 'expense_with_discount_usd',
                        label: 'Расход,$',
                        sortable: true
                    },
                    {
                        key: 'revenue_usd',
                        label: 'Доход,$',
                        sortable: true
                    },
                    {
                        key: 'profit',
                        label: 'Прибыль,$',
                        sortable: true
                    },
                    {
                        key: 'roi',
                        label: 'ROI,%',
                        sortable: true
                    },
                    {
                        key: 'leads_count',
                        label: 'Количество лидов',
                        sortable: true
                    },
                    {
                        key: 'lead_rate',
                        label: 'Ставка,$',
                        sortable: true
                    },
                    {
                        key: 'gm_rev',
                        label: 'GM/REV,%',
                        sortable: true
                    },
                ],
                search: [],
                format: 'xlsx',
                sortBy: 'offer_title',
                sortDesc: true,
                sortDirection: 'desc',
                pageSize: 25,
                selectedSource: null,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                selectOffers: [],
                isXl: false,
                ru: ru,
                savedFiltersName: 'offers-report',
            }
        },
        methods: {
            getReports(page, sort, user, search, isFilter) {
                if (this.useSavedFilters == true) {
                    let filters = this.getFilters(this.savedFiltersName)

                    if (filters) {
                        page = filters.page
                        sort = filters.sort
                        user = filters.user
                        search = filters.search


                        this.passFilters(filters)
                    }
                }
                if (isFilter) {
                    this.isBusy = true;
                }
                if (!page) {
                    page = 1;
                }

                if (!sort) {
                    sort = this;
                }

                let userArray = [];

                if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                    if (this.user && this.user.length != 0) {
                        this.user.forEach(function (userItem) {
                            userArray.push(userItem.id)
                        });
                    } else {
                        userArray.push('all')
                    }
                }

                if (this.$currentUser.role == 'user') {
                    userArray.push(this.$currentUser.id);
                }

                let sourceArray = [];

                if (this.source && this.source.length != 0) {
                    this.source.forEach(function (sourceItem) {
                        sourceArray.push(sourceItem.id)
                    });
                } else {
                    sourceArray.push('all')
                }

                if (!search) {
                    search = this.search;
                }

                let searchArray = [];

                if (search.length > 0) {
                    search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substring(0, 10),
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substring(0, 10)
                };

                let params = {
                  page: page,
                  sortBy: sort.sortBy,
                  sortDesc: sort.sortDesc,
                  search: searchArray ? searchArray.toString() : '',
                  start: range.startDate,
                  end: range.endDate,
                  user: userArray.toString(),
                  pageSize: this.pageSize,
                  group: this.group.toString(),
                  source: sourceArray.toString(),
                  type: this.getCurrentOfferTypes().toString(),
                  isTest: this.isTest.value,
                  account: this.account.toString(),
                  application_owner: this.application_owner.value,
                  advertisers: this.filters.advertisers.length !== 0 ? this.filters.advertisers.toString() : null,
                  salesManagers: this.filters.salesManagers.length !== 0 ? this.filters.salesManagers.toString() : null,
                  channel: this.channel.toString(),
                  selectedSub4: this.selectedSub4.value ? this.selectedSub4.value : this.selectedSub4,
                  selectedGeo: this.selectedGeo,
                  selectedUserGroups: this.selectedUserGroups.toString()
                }

                let filtersObject = this.prepareFiltersObject(page, sort, search, user)

                this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

                ReportsService.getOffersReport(params)
                    .then(function (response) {
                        this.useSavedFilters = false

                        this.pager = response.reports;
                        this.reports = response.reports.data

                        let sumValues = ReportsService.getSumValues(this.reports)

                        let customRaw = {
                            offer_title: 'Итого по странице:',
                            expense_with_discount_usd: sumValues.sumExpenseWithDiscountUsd,
                            revenue_usd: sumValues.sumRevenueUsd,
                            profit: sumValues.sumProfit,
                            roi: sumValues.sumRoi,
                            gm_rev: sumValues.sumGmRev,
                            _rowVariant: 'secondary'
                        };

                        let customSecondRaw = {
                            offer_title: 'Итого:',
                            expense_with_discount_usd: response.sumValues.length > 0 && response.sumValues[0].expense_with_discount_usd ? response.sumValues[0].expense_with_discount_usd : 0.00,
                            revenue_usd: response.sumValues.length > 0 && response.sumValues[0].revenue_usd ? response.sumValues[0].revenue_usd : 0.00,
                            profit: response.sumValues.length > 0 && response.sumValues[0].profit ? response.sumValues[0].profit : 0.00,
                            roi: response.sumValues.length > 0 && response.sumValues[0].roi ? response.sumValues[0].roi : 0.00,
                            gm_rev: response.sumValues.length > 0 && response.sumValues[0].gm_rev ? response.sumValues[0].gm_rev : 0.00,
                            _rowVariant: 'secondary'
                        };

                        this.reports.push(customRaw)
                        this.reports.push(customSecondRaw)
                        this.isBusy = false;
                    }.bind(this))
            },
            getOffersForSelect() {
                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }
                let user = null;

                OffersService.getOffers(1, sort, null, range, user, true)
                    .then(function (response) {
                        this.selectOffers = response;

                    }.bind(this))
            },
            prepareFiltersObject(page, sort, search, user) {
                let object = {
                    page: page,
                    sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
                    search: search,
                    type: this.type,
                    account: this.account,
                    pageSize: this.pageSize,
                    range: this.range,
                    group: this.group,
                    user: user ? user : this.user,
                    source: this.source,
                    isTest: this.isTest,
                    application_owner: this.application_owner,
                    advertisers: this.filters.advertisers,
                    salesManagers: this.filters.salesManagers,
                    channel: this.channel,
                    selectedSub4: this.selectedSub4,
                    selectedGeo: this.selectedGeo,
                    selectedUserGroups: this.selectedUserGroups
                }

                return object;
            },
            passFilters(filters) {
                this.range = this.dateConvert(filters.range.startDate, filters.range.endDate)
                this.search = filters.search
                this.type = filters.type
                this.account = filters.account
                this.pageSize = filters.pageSize
                this.group = filters.group
                this.source = filters.source
                this.isTest = filters.isTest
                this.application_owner = filters.application_owner
                this.filters.advertisers = filters.advertisers
                this.filters.salesManagers = filters.salesManagers
                this.channel = filters.channel
                this.user = filters.user
                this.selectedSub4 = filters.selectedSub4
                this.selectedGeo = filters.selectedGeo
                this.selectedUserGroups = filters.selectedUserGroups
            },
            getCountries() {
              OffersService.getCountries()
                .then(function (response) {
                  let countries = [];

                  response.forEach(function (item) {
                    countries.push(item.code);
                  });

                  this.geo = countries;
                }.bind(this))
            },
            getUserGroups() {
              let sort = {
                sortBy: null,
                sortDesc: null
              }

              UsersService.getUserGroups(sort)
                .then(userGroups => {
                  this.userGroups = userGroups;
                })
            },
            getExcelParamsString(format) {
                let userArray = [];

                if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                    if (this.user && this.user.length != 0) {
                        this.user.forEach(function (userItem) {
                            userArray.push(userItem.id)
                        });
                    } else {
                        userArray.push('all')
                    }
                }

                if (this.$currentUser.role == 'user') {
                    userArray.push(this.$currentUser.id);
                }

                let accountArray = [];

                if (this.$currentUser.role != 'user') {
                    if (this.account && this.account.length != 0) {
                        this.account.forEach(function (userItem) {
                            if (userItem.market_user_id) {
                                accountArray.push(userItem.market_user_id)
                            }
                            if (userItem.network_user_id) {
                                accountArray.push(userItem.network_user_id)
                            }
                        });
                    } else {
                        accountArray.push('all')
                    }
                }

                let sourceArray = [];

                if (this.source && this.source.length != 0) {
                    this.source.forEach(function (sourceItem) {
                        sourceArray.push(sourceItem.id)
                    });
                } else {
                    sourceArray.push('all')
                }

                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substring(0, 10),
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10): new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substring(0, 10)
                };

                let searchArray = [];

                if (this.search.length > 0) {
                    this.search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                format = format ? format : this.format

                let AUTH_TOKEN = Ls.get('auth.token')
                let sub4 = this.selectedSub4.value ? this.selectedSub4.value : this.selectedSub4;

                return '/reports/export?subject=offers&sortBy=' + this.sortBy
                  + '&sortDesc=' + this.sortDesc + '&start=' + range.startDate + '&end=' + range.endDate
                  + '&user=' + userArray + '&search=' + searchArray + '&group=' + this.group
                  + '&source=' + sourceArray + '&format=' + format + '&token=' + AUTH_TOKEN + '&isTest=' + this.isTest.value
                  + '&type=' + this.getCurrentOfferTypes() + '&account=' + accountArray
                  + '&application_owner=' + this.application_owner.value
                  + '&salesManagers=' + this.filters.salesManagers + '&advertisers=' + this.filters.advertisers
                  + '&channel=' + this.channel
                  + '&selectedSub4=' + sub4 + '&selectedGeo=' + this.selectedGeo
                  + '&selectedUserGroups=' + this.selectedUserGroups;
            },
            selectRange(event) {
                this.range = event;
            },
            resetFilters() {
                this.search = '';
                this.user = this.$currentUser.role == 'leader' ? [this.$currentUser] : null;
                this.source = [];
                this.group = [];
                this.channel = [];
                this.isTest = {value: 0, label: 'Не тест'};
                this.selectedSub4 = ''

                this.range = {
                    startDate: null,
                    endDate: null
                };
                this.type = []
                this.application_owner = Object.assign({}, this.applicationOwnerOptions[this.application_owner_default_option_idx])
                this.filters = {advertisers: [], salesManagers: []}
                this.selectedUserGroups = []

                //re-initialize element
                this.dateRange++;

                this.getReports();
            },
            filterOffers(options, search) {
                if (search) {
                    return options.filter(option => {
                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 || option.id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
            getUsers() {
                OffersService.getUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            getAccounts() {
                OffersService.getAccounts()
                    .then(users => {
                        this.accounts = users
                    })
            },
            getLeaderUsers() {
                OffersService.getLeaderUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            getSources() {
                ReportsService.getSourcesForSelect()
                    .then(function (response) {
                        this.sources = response
                    }.bind(this))
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                this.isMobile = this.window.width < 415;
                this.isXl = this.window.width > 1199;
            }
        },
        beforeMount() {
            this.useSavedFilters = true

            if (this.$currentUser.role == 'leader') {
                this.getLeaderUsers()
            } else if (this.$currentUser.role == 'admin') {
                this.getUsers()
            }
            this.getAccounts();
            this.getGroups();
            this.getSources();
            this.getReports();
            this.getOffersForSelect();
            this.getAdvertisers();
            this.getActiveSalesManagers();
            this.getActiveAccountManagers();
            this.getCountries();
            this.getUserGroups();
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }
    .geoComponent .vs__selected {
      margin: 2px 2px 4px 0 !important;
    }
    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
        height: 35px;
    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
        height: 35px;
    }

    .mainButton {
        width: 100%;
    }

    .date {
        width: 100%;
    }

    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    .input-group-append {
        width: 100%;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }

    .myOffers {
        padding-top: 4px;
    }

    .geoComponent .vs__search {
        margin: 2px 0 0;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    .reportrange-text {
        font-size: 0.9rem;
        min-width: 150px;
        width: 110%!important;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 1200px) {
        .myOffers {
            max-width: 14.66666667% !important;
        }

        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }

        .myOffers {
            max-width: 12.66666667% !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }

        .myOffers {
            max-width: 11.66666667% !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }

        .myOffers {
            max-width: 9.66666667% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/OffersReport.vue